import { MatTableDataSource } from '@angular/material/table'
import { MasterKey } from '@overtur-monorepo/keying-hierarchy'

export class Library {
  books: Book[] = []
  stats: Stats = new Stats()
  keyways: string[]
  processing = true
}

export class Book {
  pages: Page[] = []
  stats: Stats = new Stats()
  id: number
  name = 0
  keyways: string[]
  isSaved: boolean
  isFormatted: boolean
  mask
  assignmentString
  sequenceOfProgression
  bookNumber
  masterKeyBitting
  keyBitArray
  keywayId: number
  splitCombineBittings
  splitBittings
  combineBittings
  allBittings = []
  keySectionName?: string
}

export class Page {
  columns: Column[] = []
  show = true
  selected = false
  isMinimized = false
  parent: Book
  keyway: any
  splitTracker = {}
  combineType
  canCombine = true
  undoCombination
}

export class Column {
  blocks: Block[] = []
  selected = false
  disabled = false
  parent: Page
  isMinimized = false
  number
  combineType
  canCombine = true
  undoCombination
}

export class Block {
  id
  kbas: KeyBitArray[] = []
  selected = false
  disabled = false
  parent: Column
  isMinimized = false
  children: KeyBitArray[]
  number: number
  bittingsArray = []
  isCombine = false
  canCombine = true
  combineType
  undoCombination
}

export class KeyBitArray {
  bittingErrors
  bits: Bit[] = []
  selected = false
  disabled = false
  show = true
  parent: Block
  assignment: Assignment = new Assignment()
  hasWarning = false
  hasError = false
  combinationBittingReservationTypeId
  combinationBittingReservationType
  combinationBittingReservationNotes
  hidden = false
  isASplit = false
  isCombine = false
  splitCombineBittings
  masterKeyBitting
  assignedMasterKeyId
  children: KeyBitArray[]
  level
  number
  combineType
  error = false
  willCombine = false
  willSplit = false
  lineTracker = {}
  flatBits() {
    let flat = ''
    this.bits.forEach((bit) => {
      flat = flat + bit.value
    })
    return flat
  }
}

export class Bit {
  value: any
  hasWarning = false
  warning: string
  hasError = false
  inFilter = false
  error: string
}

export class Stats {
  total = 0
  assigned = 0
  available = 0
  assignments = []
}

export class Assignment {
  masterKey: MasterKey
  reserved: boolean
  reservationType?: ReservationType = new ReservationType()
  reservationNote?: string
  kba
}

export class ReservationType {
  id: number
  description: string
}

//////

export class Structure {
  id: number
  groupId: number
  name: string
  city: string
  stateCode: string
  countryCode: string
  createdBy: string
  createdOn: string
  hasDocuments: boolean
  keySystems: KeySystem[] = []
  showSystems = false
  keywayFamily: string
  keywayFamilyName
  activeUser: string
  combinatingRule: string
  combinatingRuleSetName
  structureNumber: number
  workgroupType: string
  keywayFamilyId
  chamberTypeId
  structureId
  chamberCount: number
  combinatingRuleSetId
  statusId = 1
  status: number
  keyName: string
  lockedBy: string
  lockedById: number
}

export class AuditOrderData {
  orderNumber: string
  lineNumber: string
  userName: string
  keyway: string
  keywayFamily: string
  subLineNumber: string
  keySetSymbol: string
  operatedBy: string
  variation: string
  status: string
  inbound: string
  inboundDateTime: string
  outbound: string
  outboundDateTime: string
  newValue: string
  rpa: string
  date: string
  tmkName: string
  actionType: string
  actionDescription: string
  originalOrderNumber: string
}

export class KeySystem {
  jobName: string
  date: Date
  pinCount: number
  city: string
  state: string
  country: string
  activeUser: string
  structureNumber: string
  tmkName: number
  keywayFamily: string
  originalOrder: number
  notes: Note[]
  masterKeysBudget: MasterKey
  masterKeysKeying: MasterKey
  topMasterKey: string
  isPublished = false
  constructionTypeId: number
  isDealerKeySystem: boolean
  isDummyTopMaster: boolean
  keySetSymbol: string
  keySystemId: string
  lockedById: number
  manufacturerId: number
  topMasterKeyName: string
  topMasterKeySection: string
  createdBy: string
  mecsProgressPercentage?: number
  structureId?: number
  isPreviouslyPublished: boolean

  // From API
  IsDeleted: string
  createdOn: any
  modifiedOn
  id: number
  isIndependentKeySystem: boolean
  isMasterKeyProvided: boolean
  useDhiNomenclature: boolean
  statusId: number
  orderNumber: string
  orderId: number
  isRejected: boolean
  lockedBy
}

export class Note {
  createdBy: string
  createdOn: Date
  entityId: string
  id: number
  isDeleted: boolean
  message: string
  noteType: number
  noteTypeName?: string // Added dynamically by NotesService
  dateSent?: Date
  email?: string
  orderNumber?: string
}

export class RegisterNumber {
  masterKeyId: number
  keySetSymbol: string
  registerNumber: string
  canUpdateRegisterNumber: boolean
}

export class Cylinder {
  name: string
  keywayName: string
  id
  errors: []
  keySystemId
  shearLines: ShearLines
  formattedShearLines
  masterKeyId
  chambers: Chamber[]
  operators: Operator[]
  readyForMecs = false
  mecsErrors = []
  masterKeyTypeId
  keywayId
  keySetSymbol
  competitorId: number
  isPublished: boolean
  isDefaultCylinder: boolean
  isLegacyPublished: boolean
  cylinderTypeId: number
  requiredPinningGeneration: boolean
  setlist?: string
}

export class Chamber {
  canEmpty: boolean
  isEmpty: boolean
}

export class Operator {
  bitting: string
  id: 32
  masterKeyCylinderOperatorId: '5c20e9b9-b8c5-4ffe-9b19-8648f741a795'
  isDefault: boolean
  name: string
  keywayName: string
  keywayId
  isFutureKey: boolean
  keyFunction: string
}

export class ShearLines {
  id: number
  length: number
  masterKeyCylinderId: number
  shearLineDepths = []
  chambers = []
  errors = []
  flat() {
    let flatShearLineDepths = []
    this.shearLineDepths.forEach((row) => {
      let flat = ''
      row.forEach((pin) => {
        if (pin === '') {
          pin = 'X'
        }
        flat = flat + pin
      })
      flatShearLineDepths.push(flat)
    })

    return flatShearLineDepths
  }
}

export class ChamberValidation {
  position: number
  errors = []
}

export class StructureDetails {
  mecsInProgress: boolean
  publishingInProgress: boolean
  hasUnassignedKeys: boolean
  hasIndependentSystems: boolean
  hasCylindersWithNoPinning: boolean
  totalCylindersWithNoPinning: number
  totalCrossKeyedCylindersWithNoPinning: number
  hasCylindersAwaitingUserAttention: boolean
  pinningGenerationInprogress: boolean
  pinningGenerationPercentageOfCompletion: number
  allIndependentSystemsPublished: boolean
  isFromIcom: boolean
}

export class PaginatedSearchStructureDto {
  JobName: string
  ActiveUser: Date
  StructureNumber: string
  City: string
  State: string
  Country: string
  TopMasterKeyName: string
  TopMasterKeySection: Date
  KeywayFamily: string
  ChamberCount: number
  OrderNumber: string
  RegisterNumber: string
  Combination: string
  KeySection: Date
  PageIndex: number
  PageSize: number
  SortBy: string
  IsAsc: boolean
}

export class PaginatedList<T> {
  totalItems: number
  pageIndex: number
  totalPages: number
  startItem?: number
  endItem?: number
  items: Array<T>
  hasNextPage?: boolean
  hasPreviousPage?: boolean
}

export class OrderDetails {
  orderId: number
  orderNumber: string
  createdOn: string
  userName: string
  oracleHeaderId: string
  customerAccountNumber: number
  status: string
  sublines: Subline[]
}

export class Line {
  id: number
  orderId: number
  lineNumber: string
  subLines: Subline[] = []
}

export class Subline {
  orderId: number
  lineId: number
  lineNumber: string
  subLineNumber: number
  groupName?: string
  prefix?: string
  from?: string
  to?: string
  suffix?: string
  setList?: string
  subLineQuantity: number
  keyCombination?: string
}

export interface MoveBittingsRequest {
  sourceBookId: number
  bittings: string[]
}

export class BittingDataSets {
  library
  matrix
}

export interface BittingSearchResult {
  keySetSymbol: string
  bookNumber: string
  keySection: string
  bitting: string
}
